import { render, staticRenderFns } from "./dashboardCard.vue?vue&type=template&id=8673b814&scoped=true&"
import script from "./dashboardCard.vue?vue&type=script&lang=js&"
export * from "./dashboardCard.vue?vue&type=script&lang=js&"
import style0 from "./dashboardCard.vue?vue&type=style&index=0&id=8673b814&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8673b814",
  null
  
)

export default component.exports